// to easily copy and paste components
import React from 'react';
import { withTranslation } from 'react-i18next';
import Parent from '../parent';
import './dropdown.scss'
import {BllinkLogger} from "../utils/bllink_loggers";

/// will be used in the future as a generic component for all dropdowns

export class DropDown extends Parent {


    render() {
        // const {t} = this.props;
        // BllinkLogger.info(`select dropdown got `, this.props);
        const options = this.props.options || {};
        let additionEmptyOption;
        if (this.props.includeEmptyOption){
            const fakeKey=500;
            additionEmptyOption = <option key={fakeKey} />
        }
        let parentClass = this.props.className ? `${this.props.className} selectParent` : 'selectParent';
        if (this.props.insideSelectBox){
            parentClass += ' insideSelectBox'
        }
        if (this.props.underManagerSelect){
            parentClass += ' underManagerSelectMethod'
        }

        return (
            <div className={parentClass}>
                <select
                    id={this.props.id}
                    name={this.props.name}
                    className={this.props.className}
                    onChange={e => {
                        BllinkLogger.info(`drop down on change `, this.props.onSelectChange)
                        if (this.props.onSelectChange) {
                            this.props.onSelectChange(e.target.value, this.props.callingObj)
                        }}}

                    onFocus={e => {
                        BllinkLogger.info(`drop down on change `, this.props.onFocus)
                        if (this.props.onFocus && e.target) {
                            this.props.onFocus(e.target.value, this.props.callingObj)
                        }}}
                    value={this.props.value}
                >
                    {additionEmptyOption}
                    {options.map((value, index) => {
                        // BllinkLogger.info(`dropdown value (default is ${this.props.value})`, value);
                        const isObj = typeof value === 'object' && value !== null;
                        const valueKey = isObj ? value.value: value;
                        const label = isObj ? value.label: value;
                        return <option key={index} value={valueKey} >{label}</option>
                    })}
                </select>
            </div>
        )
    }
}

export default withTranslation()(DropDown);

